/* eslint-disable array-callback-return */

import { ChangeEvent, useEffect, useMemo, useState } from 'react';

import { useAtom } from 'jotai';
import { useRouter } from 'next/router';
import { SSRConfig } from 'next-i18next';
import { HiFilter, HiLocationMarker } from 'react-icons/hi';
import { IoFilterOutline } from 'react-icons/io5';
import { IconType } from 'react-icons/lib';
import { MdNotificationAdd } from 'react-icons/md';
import { useReadLocalStorage, useWindowSize } from 'usehooks-ts';

import { categories, governorates } from '@/lib/helpers';
import { pageLoading } from '@/lib/store';
import AlertModal from '@/tayara-kit/AlertModal';
import CheckBox from '@/tayara-kit/Checkbox';
import CriteriaSelect from '@/tayara-kit/CriteriaSelect';
import MultiSelectCheckbox from '@/tayara-kit/MultiSelectCheckbox';
import Range from '@/tayara-kit/Range';

import DualColumn from './DualColumn';
import FilterBadge from './FilterBadge';
import NarrowFilterScaffold from './NarrowFilterScaffold';
import { useElastisearchFilter } from '../hooks/useElasticSearchServer';
import useFilterSelect from '../hooks/useFilterSelect';
import { useSaveSearchHook } from '../hooks/useSaveSearchHook';

export interface ICriteria extends SSRConfig {
  label?: string;
  icon?: IconType;
  options?: string[];
  asideRefWidth: number;
}

const NarrowFilter: React.FunctionComponent<ICriteria> = () => {
  const { newSaveSearchFn, verifySaveSearchUnique, disabledSaveSearchBtn } =
    useSaveSearchHook();
  const {
    selectedPrice,
    handlePriceRange,
    governorate,
    handleGovernorate,
    delegation,
    handleDelegation,
    delegationList,
    category,
    handleCategory,
    subCategory,
    handleSubCategory,
    subCategoryList,
    optionsParams,
    handleOptionsParams,
    rangeParams,
    handleRangeParams,
    paramsList,
    handleResetFilter,
    handleProductType,
    productType,
    handleOptionsParamsInput,
  } = useFilterSelect(verifySaveSearchUnique);

  // const [initSearchWithFilter] = useMeilisearchFilter();
  // const [isVisible, setIsVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [initSearchWithFilter] = useElastisearchFilter();
  const expiredIn = useReadLocalStorage<number>('expires_in');
  const isAuthenticated = useMemo(
    () => Date.now() / 1000 < +(expiredIn || 0),
    [expiredIn]
  );
  const router = useRouter();
  const [isImmoNeuf, setIsImmoNeuf] = useState(false);

  function SavedSearchHandler() {
    if (Date.now() / 1000 > +(+(expiredIn || 0))) {
      router.push({
        pathname: '/login',
        query: {
          redirect: router.asPath,
        },
      });
    }
  }

  function checkos() {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    return 'web';
  }

  // @ts-ignore
  const track = (event) => {
    // @ts-ignore
    if (window.rudderanalytics?.track) {
      window.rudderanalytics.track(event, {
        platform: checkos(),
        // query
        // subCategory
        // location
        // delegations
        // price
      });
    }
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.pageYOffset > 500) {
  //       setIsVisible(true);
  //     } else {
  //       setIsVisible(false);
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  // const [showPopup, setShowPopup] = useState(false);

  // useEffect(() => {
  //   const hasPopupBeenShown = localStorage.getItem('hasPopupBeenShown');
  //   if (!hasPopupBeenShown) {
  //     setTimeout(() => {
  //       setShowPopup(true);
  //       localStorage.setItem('hasPopupBeenShown', `${true}`);
  //     }, 4000);
  //   }
  // }, []);

  // function handleCloseOnboarding() {
  //   setShowPopup(false);
  // }
  useEffect(() => {
    const isImmo =
      router.pathname
        .split('/')
        .some((segment) => segment.toLowerCase() === 'immoneuf') ||
      router?.query?.category === 'ImmoNeuf';
    setIsImmoNeuf(isImmo);
  }, [router]);
  const displayListParams = useMemo(
    () =>
      paramsList.flatMap(
        ({ name = '', type, possiblesValues, disabled }, i) => {
          switch (type) {
            case 'array':
              return [
                <div className="pt-4" key={i}>
                  <CriteriaSelect
                    onChange={(event) => {
                      handleOptionsParams(event, name);
                    }}
                    value={
                      optionsParams !== undefined &&
                      Object.keys(optionsParams).length !== 0
                        ? optionsParams[name]
                        : undefined
                    }
                    displayLabel={name || ''}
                    disabled={disabled}
                    options={
                      possiblesValues?.map((possiblesValue) => ({
                        label: possiblesValue,
                        value: possiblesValue,
                      })) ?? []
                    }
                  ></CriteriaSelect>
                </div>,
              ];
            case 'checkbox':
              return possiblesValues
                ? possiblesValues.map((value, index) => (
                    <div className="w-full" key={`checkbox-${index}`}>
                      <label className="text-sm text-gray-700 font-bold m-2">
                        <input
                          checked={optionsParams && value in optionsParams}
                          className="w-4 h-4 accent-neuf-200 text-neuf-200 bg-gray-100 rounded border-gray-300    dark:bg-gray-700 dark:border-gray-600 mx-1 "
                          type="checkbox"
                          value={value}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            handleOptionsParamsInput(event, value);
                          }}
                        />
                        {value}
                      </label>
                    </div>
                  ))
                : [];

            case 'number':
              return [
                <div className="col-span-2" key={i}>
                  <Range
                    valueMax={rangeParams[name]?.selectedMax || ''}
                    valueMin={rangeParams[name]?.selectedMin || ''}
                    onChangeMax={(selectedMax) =>
                      handleRangeParams('setMax', name, selectedMax)
                    }
                    onChangeMin={(selectedMin) =>
                      handleRangeParams('setMin', name, selectedMin)
                    }
                    displayLabel={name || ''}
                  />
                </div>,
              ];

            default:
              return [];
          }
        }
      ),
    [
      paramsList,
      optionsParams,
      handleOptionsParams,
      rangeParams,
      handleRangeParams,
      handleOptionsParamsInput,
    ]
  );
  const windowSize = useWindowSize();

  const [isOpen, setIsOpen] = useState(false);

  const [isLoading] = useAtom(pageLoading);

  return (
    <>
      {windowSize.width < 1024 ? (
        <>
          {!isLoading && (
            <div
              className={`fixed top-[150px]  left-0 w-full transition duration-300 z-[9998]`}
            >
              <div className="w-full py-2 px-8 flex  gap-1 justify-center  align-middle items-center bg-white/90 bg-blend-overlay backdrop-blur-xl ">
                <span
                  className={`flex justify-center w-full px-4 py-2.5 rounded-lg ${
                    isImmoNeuf ? 'bg-neuf-200' : 'bg-primary'
                  } items-center font-light text-gray-700 capitalize space-x-2 cursor-pointer`}
                  onClick={() => setIsOpen(true)}
                >
                  <IoFilterOutline className="text-white" size={18} />
                  <span className="text-white truncate text-sm font-semibold">
                    Filtres Avancés
                  </span>
                </span>

                <button
                  aria-label="Créer une alerte"
                  className={`relative flex  z-50 w-fit text-white  rounded-lg justify-center p-[9.5px]  bg-info items-center font-light ${
                    (isAuthenticated ? disabledSaveSearchBtn : false)
                      ? 'bg-info/50'
                      : 'btn-info'
                  } `}
                  disabled={isAuthenticated ? disabledSaveSearchBtn : false}
                  onClick={
                    isAuthenticated
                      ? () => {
                          if (newSaveSearchFn)
                            newSaveSearchFn().then(() => {
                              setShowModal(true);
                              verifySaveSearchUnique();
                              track('Saved search');
                            });
                        }
                      : () => {
                          SavedSearchHandler();
                          track('Saved search notLoggedIn');
                        }
                  }
                >
                  <MdNotificationAdd size={20} className="mx-2" />
                </button>
              </div>
            </div>
          )}

          {isOpen && (
            <div className="fixed overflow-hidden inset-0 flex justify-start flex-col h-full bg-white z-[9999]">
              <NarrowFilterScaffold
                onResetFilter={handleResetFilter}
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              >
                <div className="w-full lg:h-[calc(100vh-260px)] lg:overflow-y-auto">
                  <FilterBadge />
                  <DualColumn>
                    <div className="col-span-2">
                      <Range
                        displayLabel="Prix (DT)"
                        onChangeMax={(value) =>
                          handlePriceRange({
                            min: selectedPrice.min,
                            max: value,
                          })
                        }
                        onChangeMin={(value) =>
                          handlePriceRange({
                            min: value,
                            max: selectedPrice.max,
                          })
                        }
                        valueMin={selectedPrice.min || ''}
                        valueMax={selectedPrice.max || ''}
                      />
                    </div>
                    <CriteriaSelect
                      icon={HiLocationMarker}
                      onChange={handleGovernorate}
                      displayLabel="Ville"
                      value={governorate !== null ? governorate.id : undefined}
                      options={governorates
                        .map(({ id, name }) => ({
                          value: id,
                          label: name,
                        }))
                        .sort((a, b) => {
                          if (a.label < b.label) {
                            return -1;
                          }
                          if (a.label > b.label) {
                            return 1;
                          }
                          return 0;
                        })}
                    ></CriteriaSelect>
                    <MultiSelectCheckbox
                      values={delegation}
                      onChange={handleDelegation}
                      displayLabel="Délégation"
                      options={delegationList
                        .map(({ id, name }) => ({
                          value: id,
                          label: name,
                        }))
                        .sort((a, b) => {
                          if (a.label > b.label) {
                            return -1;
                          }
                          if (a.label < b.label) {
                            return 1;
                          }
                          return 0;
                        })}
                    ></MultiSelectCheckbox>
                    <CriteriaSelect
                      onChange={handleCategory}
                      value={category.id}
                      displayLabel="Catégorie"
                      options={categories
                        .filter((cat) => cat.parentcategoryxid === '')
                        .map(({ id, name }) => ({
                          value: id,
                          label: name,
                        }))}
                    ></CriteriaSelect>
                    <CriteriaSelect
                      onChange={handleSubCategory}
                      value={subCategory.id}
                      displayLabel="Sous-catégorie"
                      options={subCategoryList}
                    ></CriteriaSelect>
                    {!isImmoNeuf ? (
                      <CheckBox
                        onChange={handleProductType}
                        options={[
                          {
                            label: 'Neuf',
                            id: 1,
                          },
                          {
                            label: 'Occasion',
                            id: 0,
                          },
                        ]}
                        displayLabel={'État de produit :'}
                        value={productType}
                      />
                    ) : (
                      <></>
                    )}
                  </DualColumn>
                  <DualColumn>{displayListParams}</DualColumn>
                </div>
                <div className=" relative  flex w-full gap-x-2 h-[3rem] mt-4 lg:mt-0">
                  <button
                    aria-label="Filtrer"
                    className={`flex items-center justify-center ${
                      isImmoNeuf
                        ? 'bg-neuf-200'
                        : 'bg-primary hover:bg-primary-focus'
                    } rounded-lg  w-5/6 `}
                    onClick={() => {
                      initSearchWithFilter();
                      setIsOpen(false);
                    }}
                  >
                    <HiFilter size={20} className=" text-white mr-6" />
                    <span className="tracking-widest uppercase font-normal text-white">
                      Filtrer
                    </span>
                  </button>
                  {/* {showPopup && (
                    <div
                      className="fixed z-[9999] top-0 left-0 w-full h-full bg-neutral-800/50 bg-opacity-90 justify-center items-center"
                      onClick={(e) => {
                        if (e.target !== e.currentTarget) return;
                        handleCloseOnboarding();
                      }}
                    >
                      <div className=" w-[20rem] lg:w-[35rem] absolute bottom-[6rem] lg:bottom-[2rem] right-6 lg:right-[2rem] flex justify-center flex-wrap lg:flex-nowrap bg-white border border-info shadow-slate-400 rounded-lg  p-6 lg:p-5 shadow-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="absolute top-1 right-2 w-8 h-8 stroke-white fill-primary self-end cursor-pointer"
                          onClick={() => handleCloseOnboarding()}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>

                        <img
                          src="/media/savedSearchInfo.svg"
                          alt="tayara - Information about saved searches"
                          className="hidden md:block lg:block self-center mb-4 items-center justify-center w-48 "
                        />

                        <div className="flex flex-col mb-5 mt-3">
                          <h2 className="text-lg lg:text-xl font-medium ml-2 lg:ml-0 mb-4 self-center">
                            Voulez vous être au courant des nouveautés de vos
                            recherches?
                          </h2>
                          <h2 className="text-sm lg:text-base font-medium mb-4 ml-3 lg:ml-4">
                            !تلوجلك عليه{' '}
                            <span className="text-xl font-extrabold text-primary">
                              {' '}
                              tayara{' '}
                            </span>
                            ما لقيتش إلي حاجتك بيه؟
                          </h2>

                          <button
                            aria-label="Mes recherches sauvegardées"
                            onClick={() => handleCloseOnboarding()}
                            className={` w-[18rem] ml-2 lg:ml-10 shadow-neutral-400 shadow-md cursor-default
                            right-[1rem] bottom-[2rem] duration-700 ease-out flex items-center gap-x-3 py-3  pl-5 rounded-xl border-[1px]
                          text-white btn-info text-sm font-bold font-arabic hover:!border-solid `}
                          >
                            <MdNotificationAdd size={26} />
                            <h3 className="text-white text-base font-bold font-arabic block w-max">
                              Sauvegarder ma recherche
                            </h3>
                          </button>
                        </div>
                      </div>
                    </div>
                  )} */}

                  <button
                    aria-label="Créer une alerte"
                    className={`relative z-50  w-1/6 rounded-lg ${
                      (isAuthenticated ? disabledSaveSearchBtn : false)
                        ? 'bg-info/50'
                        : 'btn-info'
                    } `}
                    disabled={isAuthenticated ? disabledSaveSearchBtn : false}
                    onClick={
                      isAuthenticated
                        ? () => {
                            if (newSaveSearchFn)
                              newSaveSearchFn().then(() => {
                                setShowModal(true);
                                verifySaveSearchUnique();
                                track('Saved search');
                              });
                          }
                        : () => {
                            SavedSearchHandler();
                            track('Saved search notLoggedIn');
                          }
                    }
                  >
                    <MdNotificationAdd
                      size={20}
                      className=" text-white mx-auto"
                    />
                  </button>

                  {showModal && (
                    <AlertModal
                      showModal={showModal}
                      setShowModal={setShowModal}
                    />
                  )}
                </div>
              </NarrowFilterScaffold>
            </div>
          )}
        </>
      ) : (
        <NarrowFilterScaffold
          onResetFilter={handleResetFilter}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
        >
          <div className="w-full lg:h-[calc(100vh-310px)] lg:overflow-y-auto mb-4 pr-4 scroll-box">
            {/* <div className="my-4 drop-shadow-sm grow w-full transition-[width]  !rounded-3xl focus:!bg-neutral-600 focus:placeholder:text-white ">
              <SearchInput filter iconClasses={'text-white'} />
            </div> */}
            <FilterBadge />
            <DualColumn>
              <div className="col-span-2">
                <Range
                  displayLabel="Prix (DT)"
                  onChangeMax={(value) =>
                    handlePriceRange({ min: selectedPrice.min, max: value })
                  }
                  onChangeMin={(value) =>
                    handlePriceRange({ min: value, max: selectedPrice.max })
                  }
                  valueMin={selectedPrice.min || ''}
                  valueMax={selectedPrice.max || ''}
                />
              </div>
              <CriteriaSelect
                icon={HiLocationMarker}
                onChange={handleGovernorate}
                displayLabel="Ville"
                value={governorate !== null ? governorate.id : undefined}
                options={governorates
                  .map(({ id, name }) => ({
                    value: id,
                    label: name,
                  }))
                  .sort((a, b) => {
                    if (a.label < b.label) {
                      return -1;
                    }
                    if (a.label > b.label) {
                      return 1;
                    }
                    return 0;
                  })}
              ></CriteriaSelect>
              <MultiSelectCheckbox
                values={delegation}
                onChange={handleDelegation}
                displayLabel="Délégation"
                options={delegationList
                  .map(({ id, name }) => ({
                    value: id,
                    label: name,
                  }))
                  .sort((a, b) => {
                    if (a.label > b.label) {
                      return -1;
                    }
                    if (a.label < b.label) {
                      return 1;
                    }
                    return 0;
                  })}
              ></MultiSelectCheckbox>
              <CriteriaSelect
                onChange={handleCategory}
                value={category.id}
                displayLabel="Catégorie"
                options={categories
                  .filter((cat) => cat.parentcategoryxid === '')
                  .map(({ id, name }) => ({
                    value: id,
                    label: name,
                  }))}
              ></CriteriaSelect>
              <CriteriaSelect
                onChange={handleSubCategory}
                value={subCategory.id}
                displayLabel="Sous-catégorie"
                options={subCategoryList}
              ></CriteriaSelect>
              {!isImmoNeuf ? (
                <CheckBox
                  onChange={handleProductType}
                  options={[
                    {
                      label: 'Neuf',
                      id: 1,
                    },
                    {
                      label: 'Occasion',
                      id: 0,
                    },
                  ]}
                  displayLabel={'État de produit :'}
                  value={productType}
                />
              ) : (
                <></>
              )}
            </DualColumn>
            <DualColumn>{displayListParams}</DualColumn>
          </div>
          <div className=" relative z-[9999] flex w-full gap-x-2 h-[3rem] mt-4 lg:mt-0">
            <button
              aria-label="Filtrer"
              className={`flex items-center justify-center ${
                isImmoNeuf ? 'bg-neuf-200' : 'bg-primary hover:bg-primary-focus'
              } rounded-lg  w-5/6 `}
              onClick={() => {
                initSearchWithFilter();
              }}
            >
              <HiFilter size={20} className=" text-white mr-6" />
              <span className="tracking-widest uppercase font-normal text-white">
                Filtrer
              </span>
            </button>
            {/* {showPopup && (
              <div
                className="fixed z-[9999] top-0 left-0 w-full h-full bg-neutral-800/50 bg-opacity-90 justify-center items-center"
                onClick={(e) => {
                  if (e.target !== e.currentTarget) return;
                  handleCloseOnboarding();
                }}
              >
                <div className=" w-[20rem] lg:w-[35rem] absolute bottom-[4rem] lg:bottom-[2rem] right-5 lg:right-[2rem] flex justify-center flex-wrap lg:flex-nowrap bg-white border border-info shadow-slate-400 rounded-lg  p-6 lg:p-5 shadow-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="absolute top-1 right-2 w-8 h-8 stroke-white fill-primary self-end cursor-pointer"
                    onClick={() => handleCloseOnboarding()}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>

                  <img
                    src="/media/savedSearchInfo.svg"
                    alt="tayara - Information about saved searches"
                    className="self-center mb-4 items-center justify-center w-48 "
                  />

                  <div className="flex flex-col mb-5 mt-3">
                    <h2 className="text-lg lg:text-xl font-medium ml-2 lg:ml-0 mb-4 self-center">
                      Voulez vous être au courant des nouveautés de vos
                      recherches?
                    </h2>
                    <h2 className="text-sm lg:text-base font-medium mb-4 ml-3 lg:ml-4">
                      !تلوجلك عليه{' '}
                      <span className="text-xl font-extrabold text-primary">
                        {' '}
                        tayara{' '}
                      </span>
                      ما لقيتش إلي حاجتك بيه؟
                    </h2>

                    <button
                      aria-label="Mes recherches sauvegardées"
                      onClick={() => handleCloseOnboarding()}
                      className={` w-[18rem] ml-2 lg:ml-10 shadow-neutral-400 shadow-md cursor-default
                      right-[1rem] bottom-[2rem] duration-700 ease-out flex items-center gap-x-3 py-3  pl-5 rounded-xl border-[1px]
                    text-white btn-info text-sm font-bold font-arabic hover:!border-solid `}
                    >
                      <MdNotificationAdd size={26} />
                      <h3 className="text-white text-base font-bold font-arabic block w-max">
                        Sauvegarder ma recherche
                      </h3>
                    </button>
                  </div>
                </div>
              </div>
            )} */}

            <button
              aria-label="Créer une alerte"
              className={`relative z-50  w-1/6 rounded-lg ${
                (isAuthenticated ? disabledSaveSearchBtn : false)
                  ? 'bg-info/50'
                  : 'btn-info'
              } `}
              disabled={isAuthenticated ? disabledSaveSearchBtn : false}
              onClick={
                isAuthenticated
                  ? () => {
                      if (newSaveSearchFn)
                        newSaveSearchFn().then(() => {
                          setShowModal(true);
                          verifySaveSearchUnique();
                          track('Saved search');
                        });
                    }
                  : () => {
                      SavedSearchHandler();
                      track('Saved search notLoggedIn');
                    }
              }
            >
              <MdNotificationAdd size={20} className=" text-white mx-auto" />
            </button>

            {/* <button
              disabled={isAuthenticated ? disabledSaveSearchBtn : false}
              aria-label="Mes recherches sauvegardées"
              onClick={
                isAuthenticated
                  ? () => {
                      if (newSaveSearchFn)
                        newSaveSearchFn().then(() => {
                          setShowModal(true);
                          verifySaveSearchUnique();
                          track('Saved search');
                        });
                    }
                  : () => {
                      SavedSearchHandler();
                      track('Saved search notLoggedIn');
                    }
              }
              className={`${
                isVisible
                  ? 'translate-y-0 translate-x-0 lg:translate-y-full lg:translate-x-0 bottom-20 md:bottom-20 lg:bottom-24'
                  : ' lg:translate-y-full   translate-y-full md:translate-y-full  translate-x-0 md:translate-x-0 lg:translate-x-full'
              }  fixed  z-50  right-[1rem] xl:-right-[1rem] bottom-0 transform transition-transform duration-700 ease-out flex items-center gap-x-3 py-3 pr-10 pl-5 rounded-xl border-[1px] ${
                (isAuthenticated ? disabledSaveSearchBtn : false)
                  ? 'hidden'
                  : 'btn-info'
              } text-white text-sm font-bold font-arabic hover:!border-solid hover:!border-info hover:bg-blue-700`}
            >
              <MdNotificationAdd size={26} />
              <h3 className="text-white text-base font-bold font-arabic block w-max">
                Sauvegarder ma recherche
              </h3>
            </button> */}

            {showModal && (
              <AlertModal showModal={showModal} setShowModal={setShowModal} />
            )}
          </div>
        </NarrowFilterScaffold>
      )}
    </>
  );
};

export default NarrowFilter;

/* eslint-disable array-callback-return */
